import { apolloClientService } from "../../../../services/apollo-client";

export const usageService = {
    getDropdownData,
    usageGraphData,
};

function getDropdownData(groupCode,languageCode) {
    let APIquery= `{getDropdownData(input:{groupCode:"` +groupCode +`",languageCode:"${languageCode}"})}`;
    return apolloClientService.ApolloClientgqls(APIquery); 
 }

 function usageGraphData(saId,accountId,startDate,endDate,displayMode,mode){
    let APIquery=
    `{ getUsageTrends(input: {displayMode: "`+displayMode+`",startDate:"`+startDate+`",endDate:"`+endDate+`",
    additionalIdentifiers: [
    {
       name: "mode",
       value: "`+mode+`"
    }
   ]
   }) { 
   usageQuantity { 
       intervalName 
       intervalShortName 
       intervalDateTime 
       quantity
   } 
   usageUnit 
  }
  }`
    let headers={
      saId: saId,
      accountId:accountId
      }
      return  apolloClientService.ApolloClientgqlsUsage(APIquery,headers,"network-only"); 
  }